import { useEffect, useRef, useState } from "react";
import * as THREE from "three";
import { WorldRenderer } from "../../panels/WorldRenderer";
import { Vec2 } from "../../models/SyntheticMap";

export default function DeploymentWorldPanel({
  size,
  activeSiteId = '',
  rendererKey,
  onLoaded
}: {
  size: Vec2,
  activeSiteId: string,
  rendererKey?: string,
  onLoaded?: (wr: WorldRenderer) => Promise<void>
}) {
  const divRef = useRef<HTMLDivElement>(null);
  const [renderer, setRenderer] = useState<WorldRenderer | null>(null);
  useEffect(() => {
    if (divRef.current) {
      if (!renderer) {
        const newRenderer = new WorldRenderer(divRef.current, async () => {
          // console.log("Activating site", activeSiteId);
          await newRenderer.dataService.activateSite(activeSiteId, true);
          const site = newRenderer.dataService.activeSite!;
          site.showBox = true;
          site.showGrid = true;
          site.updateObj();
          // newRenderer.emitEvent(WREvents.VisualSelected, site);
          if (!site.settings.cameraPosition) {
            return;
          }
          const p = site.settings.cameraPosition!.position;
          let relativeToSite = new THREE.Vector3(p.x, p.y, p.z);
          relativeToSite = site.obj.worldToLocal(relativeToSite);
          newRenderer.setCameraPosition(site.settings.cameraPosition!);
          if (onLoaded) {
            await onLoaded(newRenderer);
          }
        });
        setRenderer(newRenderer);
      } else {
        onLoaded && onLoaded(renderer);
      }
    }

  }, [rendererKey, divRef]);
  useEffect(() => {
    if (!renderer) {
      return;
    }
    setTimeout(() => {
        renderer.setSize(divRef.current?.clientWidth || 0, divRef.current?.clientHeight || 0);
    }, 200);
  }, [size, renderer]);

  return (
    <div
      ref={divRef}
      style={{
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        padding: 0,
        margin: 0,
      }}
      tabIndex={0}
    />
  );
}